//
import Model from '@/models/ExtendModel'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

/**
 * @class
 */
export default class WhOrderer extends Model {
    //
    wh_selected_products = []

    //
    static includes = [
        'g_supervisor_user.hr_employee',
        'pch_provider',
        'pch_provider_branch_offices',
        'pch_purchase_orders.pch_purchase_order_state',
        'wh_detail_orderers.wh_product',
        'wh_orderer_priority',
        'wh_warehouse',
    ]

    /**
     *
     */
    get g_state_name() {
        return this.was_processed ? 'Procesada' : 'Sin procesar'
    }

    /**
     *
     */
    get g_supervisor_user_full_name() {
        return [
            this.g_supervisor_user.hr_employee.names,
            this.g_supervisor_user.hr_employee.last_name1,
            this.g_supervisor_user.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     *
     */
    get has_purchase_orders() {
        return this.pch_purchase_orders.length > 0
    }

    /**
     *
     */
    get pch_provider_branch_offices_address() {
        return this.pch_provider_branch_offices
            ? this.pch_provider_branch_offices.address
            : '-'
    }

    /**
     *
     */
    get pch_provider_rut() {
        return this.pch_provider ? this.pch_provider.rut : '-'
    }

    /**
     *
     */
    get pch_provider_alias_name() {
        return this.pch_provider ? this.pch_provider.alias_name : '-'
    }

    /**
     *
     */
    get pch_purchase_orders_state() {
        return this.has_purchase_orders
            ? this.pch_purchase_orders.slice().pop().pch_purchase_order_state
                  .state
            : '-'
    }

    /**
     *
     */
    get wh_orderer_priority_name() {
        return this.wh_orderer_priority
            ? this.wh_orderer_priority.priority
            : '-'
    }

    /**
     *
     */
    get wh_warehouse_name() {
        return this.wh_warehouse ? this.wh_warehouse.name : '-'
    }

    /**
     *
     */
    mapDetail(item) {
        return {
            net_price: Number(item.net_price),
            provider_product_code: String(item.provider_product_code),
            quantity: Number(item.quantity),
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    mapSelected(item) {
        return {
            internal_code: String(item.wh_product.internal_code),
            id: Number(item.id || 0),
            name: String(item.wh_product.name),
            net_price: Number(item.net_price || 0),
            provider_product_code: String(item.provider_product_code),
            quantity: Number(item.quantity),
            stock: Number(item.stock || 0),
            wh_product: Object(item.wh_product),
            wh_product_id: Number(item.wh_product_id),
        }
    }

    /**
     *
     */
    process() {
        return new PurchaseOrderModel(this.toProcess())
    }

    /**
     *
     */
    reset() {
        //
        this.wh_selected_products = this.wh_detail_orderers.map(
            this.mapSelected
        )
        this.pch_payment_condition_id = null

        //
        return this
    }

    /**
     * @description
     */
    resource() {
        return 'wh_orderer'
    }

    /**
     *
     */
    toProcess() {
        //
        this.details = this.wh_selected_products.map(this.mapDetail)
        this.is_service = false
        this.g_originator_user_id = this.g_supervisor_user_id
        this.orderers = [this.id]

        //
        this.observation = this.comment

        //
        return this.clean([
            'details',
            'is_exent',
            'is_service',
            'g_originator_user_id',
            'observation',
            'orderers',
            'pch_payment_condition_id',
            'pch_provider_id',
            'pch_provider_branch_offices_id',
            'wh_warehouse_id',
        ])
    }
}
